import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import { calculateAgeParse } from "../../../../Utils/Patient";
import htmlToPdfmake from "html-to-pdfmake";

/**
    VID: Ventriculo Izquierdo en diástole
    PP: Pared Posterior
    PS: Pared Septal
    VIS: Ventriculo Izquierdo en sistole
    FE: Fraccion de Eyeccion
    RAO: Raiz de Aorta
    AO: Anillo de la Orta
    VD: Ventriculo Derecho
    AI: Auricula Izquierda
    E: Onda E
    A: Onda A
    Tapse: Tapse
    AD : Auricula Derecha
    FC: Frecuencia Cardiaca
    PR: Intervalo PR
    QRS: Intervalo QRS
    STyT: Segmento STyT
    QTC: Intervalo QT Corregido
 */

const PDFProcedures = async (data) => {
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };

  console.log("CominTOPDF", data);
  const name =
    data.typeDocument + "-" + data.documentNumber + " " + data.fullname;

  const getLogos = async (data) => {
    const logos = []
    const { formato_propio, formato_detalle, id_contrato, urlLogo } = data;
    const getLogoProfile = await getBase64ImageFromURL(urlLogo);
    logos.push({ image: getLogoProfile, fit: [160, 80]})

    if (!!formato_propio && !!formato_detalle?.formato_detalle?.[0]?.logo) {
      let url =
        process.env.REACT_APP_PUBLIC_URL +
        "contratos/" +
        id_contrato +
        "/logo/" +
        formato_detalle.formato_detalle[0].logo +
        "/" +
        sessionStorage.getItem("token");
        const getLogoFormato = await getBase64ImageFromURL(url);
        logos.push({ image: getLogoFormato, fit: [120, 80]})
       
    }
    return logos
  };

  const getDetail = (data) => {
    const { formato_propio, formato_detalle } = data;
    if (!!formato_propio && !!formato_detalle?.formato_detalle?.[0]) {
      return {
        nombre: formato_detalle.formato_detalle[0].nombre,
        direccion: formato_detalle.formato_detalle[0].direccion,
        telefono: formato_detalle.formato_detalle[0].telefono,
        nit: formato_detalle.formato_detalle[0].nit,
      };
    }
    return {
      nombre: data.profile.nombre,
      direccion: data.profile.direccion.direccion,
      telefono: data.profile.telefono1,
      nit: data.profile.nit,
    };
  };

  const infoDetail = getDetail(data);
  const logos = await getLogos(data)

  const replaceConcurrenceInString = (string, search, replace) => {
    if (typeof string !== "string") return "";
    return string.split(search).join(replace);
  };

  const verifyClinicType = (types) => {
    let list = types.map((type) => type.value);
    return list.includes("3");
  };

  const header = {
    margin: [0, 0, 0, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            layout: "noBorders",
            table: {
              body: [logos],
            },
          },
          {
            layout: "noBorders",
            table: {
              body: [
                [
                  {
                    text: infoDetail.nombre,
                    style: "head",
                    bold: true,
                    alignment: "center",
                  },
                ],
                infoDetail.direccion != ""
                  ? [
                      {
                        text:
                          "Dirección: " +
                          infoDetail.direccion, 
                        style: "head",
                        bold: true,
                        alignment: "center",
                      },
                    ]
                  : [""],
                infoDetail.telefono != "" ?[{  text: "Teléfono: " + infoDetail.telefono,
                  style: "head",
                  bold: true,
                  alignment: "center",}]:[""],
                
                infoDetail.nit != ""
                  ? [
                      {
                        text: "NIT: " + infoDetail.nit,
                        style: "head",
                        bold: true,
                        alignment: "center",
                      },
                    ]
                  : [""],
                [
                  {
                    text: verifyClinicType(data?.profile?.tipo)
                      ? "IMAGENOLOGIA"
                      : "",
                    style: "head",
                    bold: true,
                    alignment: "center",
                  },
                ],
              ],
            },
          },
        ],
      ],
    },
  };

  const topTitle = () => {
    let typeClinic = verifyClinicType(data?.profile?.tipo);
    if (typeClinic) {
      return {
        margin: [0, 0, 0, 0],
        layout: {
          defaultBorder: false,
        },
        table: {
          headerRows: 1,
          widths: ["auto", "*"],
          body: [
            [
              { text: "Admisión: ", style: "textStyle", bold: true },
              { text: data.id_admision, style: "textStyle" },
            ],
          ],
        },
      };
    } else {
      if (!!data.nameProcedureTitle) {
        return {
          text: data.nameProcedureTitle,
          style: "tableheader",
          alignment: "center",
          margin: [0, 10, 0, 0],
        };
      } else {
        return {
          text: data.nameService,
          style: "tableheader",
          alignment: "center",
          margin: [0, 10, 0, 0],
        };
      }
    }
  };

  const infoDetailedService = () => {
    let typeClinic = verifyClinicType(data?.profile?.tipo);
    if (typeClinic) {
      return {
        margin: [0, 0, 0, 0],
        layout: {
          defaultBorder: false,
        },
        table: {
          headerRows: 1,

          widths: ["auto", "auto", "*"],
          body: [
            [
              { text: data.fecha_admision, style: "textStyle" },
              {
                text: "| CUPS: " + data.codigoService,
                style: "textStyle",
                bold: true,
              },
              { text: data.nameService, style: "textStyle" },
            ],
          ],
        },
      };
    } else {
      return null;
    }
  };

  const signatures = [
    {
      // auto-sized columns have their widths based on their content
      margin: [10, 10, 10, 0],
      layout: "headerLineOnly",
      table: {
        widths: [160],
        headerRows: 1,
        body: [
          [
            {
              image: await getBase64ImageFromURL(data.urlDoctorFirm),
              fit: [50, 150],
              alignment: "center",
            },
          ],
          [{ text: data.nameDoctor, style: "signatureNameDoctor" }],
          [
            {
              text:
                data.professional?.tip_documento_doctor +
                "-" +
                data.professional?.num_documento_doctor +
                " REG-" +
                data.professional?.reg_medico,
              style: "signature",
            },
          ],
          [{ text: data.professional?.especialidad, style: "signature" }],
        ],
      },
    },
  ];
  //https://i.postimg.cc/0jznYVsr/prueba.png
  const noSignaturesFound = [
    {
      // auto-sized columns have their widths based on their content
      margin: [10, 10, 10, 0],
      layout: "headerLineOnly",
      table: {
        widths: [160],
        headerRows: 1,
        body: [
          [
            {
              image: await getBase64ImageFromURL(
                "https://i.postimg.cc/0jznYVsr/prueba.png"
              ),
              fit: [50, 150],
              alignment: "center",
            },
          ],
          [{ text: data.nameDoctor, style: "signatureNameDoctor" }],
          [{ text: data.specialtyDoctor, style: "signature" }],
          [{ text: data.medicalRegister, style: "signature" }],
        ],
      },
    },
  ];

  const validateProcedures = () => {
    let arrProcedures = [];
    let defaultText = [
      {
        text: "",
        bold: true,
        style: "textStyle",
        border: [false, false, false, false],
      },
    ];
    arrProcedures.push(defaultText);

    //ECO
    if (data.eco != null) {
      /* let eco = [
                {
                    margin: [0, 0, 0, 0],
                    layout: {
                        defaultBorder: false,
                    },
                    table: {
                        widths: [150, '*', 150, '*'],
                        body: [
                            [
                                { text: 'Ventriculo Izquierdo en diástole:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.vid, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Raiz de Aorta:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.rao, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Onda E:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.e, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Pared Posterior:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.pp, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Anillo Anillo de la Orta:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.anillo_ao, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Onda A:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.a, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Pared Septal:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.ps, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Ventriculo Derecho:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.vd, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'TAPSE:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.tap_se, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Ventriculo Izquierdo en sistole:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.vis, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Auricula Izquierda:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.ai, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Auricula Derecha:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.ad, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Fraccion de Eyeccion:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.eco.fe, style: 'textStyle', border: [false, false, false, false] },
                                { text: '', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: "", style: 'textStyle', border: [false, false, false, false] }
                            ]
                        ]
                    }
                }
            ]; */
      let htmlEcoConclusion = null;
      let result = replaceConcurrenceInString(
        data.eco.conclusiones,
        "\n",
        "<br />"
      );
      htmlEcoConclusion = htmlToPdfmake(result, {
        defaultStyles: {
          table: {
            width: ["*", "auto"],
          },
        },
        tableAutoSize: true,
      });
      //htmlEcoConclusion = htmlToPdfmake(result);
      let ecoDescripction = [
        {
          margin: [0, 0, 0, 0],
          layout: {
            defaultBorder: false,
          },
          style: "tableTexStyle",
          table: {
            widths: ["*"],
            body: [[htmlEcoConclusion]],
          },
        },
      ];
      //arrProcedures.push(eco);
      arrProcedures.push(ecoDescripction);
    }

    //Stress
    if (data.estres != null) {
      /* let estres = [
                {
                    margin: [0, 0, 0, 0],
                    layout: {
                        defaultBorder: false,
                    },
                    table: {
                        widths: [150, '*', 150, '*'],
                        body: [
                            [
                                { text: 'Ventriculo Izquierdo en diástole:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.vid, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Raiz de Aorta:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.rao, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Onda E:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.e, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Pared Posterior:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.pp, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Anillo Anillo de la Orta:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.anillo_ao, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Onda A:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.a, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Pared Septal:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.ps, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Ventriculo Derecho:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.vd, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'TAPSE:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.tap_se, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Ventriculo Izquierdo en sistole:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.vis, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Auricula Izquierda:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.ai, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Auricula Derecha:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.ad, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Fraccion de Eyeccion:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.estres.fe, style: 'textStyle', border: [false, false, false, false] },
                                { text: '', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: "", style: 'textStyle', border: [false, false, false, false] }
                            ]
                        ]
                    }
                }
            ]; */
      let htmlStressConclusion = null;
      //htmlStressConclusion = htmlToPdfmake(data.estres.conclusiones);
      let result = replaceConcurrenceInString(
        data.estres.conclusiones,
        "\n",
        "<br />"
      );
      htmlStressConclusion = htmlToPdfmake(result, {
        defaultStyles: {
          table: {
            width: ["*", "auto"],
          },
        },
        tableAutoSize: true,
      });
      let estresDescripction = [
        {
          margin: [0, 0, 0, 0],
          layout: {
            defaultBorder: false,
          },
          style: "tableTexStyle",
          table: {
            widths: ["*"],
            body: [[htmlStressConclusion]],
          },
        },
      ];
      //arrProcedures.push(estres);
      arrProcedures.push(estresDescripction);
    }

    //Test
    if (data.prueba != null) {
      let htmlPruebaConclusion = null;
      let result = replaceConcurrenceInString(
        data.prueba.conclusiones,
        "\n",
        "<br />"
      );
      htmlPruebaConclusion = htmlToPdfmake(result, {
        defaultStyles: {
          table: {
            width: ["*", "auto"],
          },
        },
        tableAutoSize: true,
      });
      //htmlPruebaConclusion = htmlToPdfmake(result);
      let pruebaDescripction = [
        {
          margin: [0, 0, 0, 0],
          layout: {
            defaultBorder: false,
          },
          style: "tableTexStyle",
          table: {
            widths: ["*"],
            body: [[htmlPruebaConclusion]],
          },
        },
      ];
      arrProcedures.push(pruebaDescripction);
    }

    //Holter
    if (data.holter != null) {
      let htmlHolterConclusion = null;

      let result = replaceConcurrenceInString(
        data.holter.conclusion,
        "\n",
        "<br />"
      );

      htmlHolterConclusion = htmlToPdfmake(result, {
        defaultStyles: {
          table: {
            width: ["*", "auto"],
          },
        },
        tableAutoSize: true,
      });

      //htmlHolterConclusion = htmlToPdfmake(result, { tableAutoSize: true });

      let holterDescripction = [
        {
          margin: [0, 0, 0, 0],
          layout: {
            defaultBorder: false,
          },
          style: "tableTexStyle",
          table: {
            widths: ["*"],
            body: [[htmlHolterConclusion]],
          },
        },
      ];
      arrProcedures.push(holterDescripction);
    }

    //EKG
    if (data.ekg != null) {
      /* let ekg = [
                {
                    margin: [0, 0, 0, 0],
                    layout: {
                        defaultBorder: false,
                    },
                    table: {
                        widths: [150, '*', 150, '*'],
                        body: [
                            [
                                { text: 'Frecuencia Cardiaca:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.ekg.fc, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Intervalo PR:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.ekg.pr, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Intervalo QRS', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.ekg.qr_s, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Ritmo:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.ekg.ritmo, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Onda P:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.ekg.onda_p, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Eje QRS:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.ekg.eje_qrs, style: 'textStyle', border: [false, false, false, false] }
                            ],
                            [
                                { text: 'Segmento STyT:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.ekg.styt, style: 'textStyle', border: [false, false, false, false] },
                                { text: 'Intervalo QT Corregido:', bold: true, style: 'textStyle', border: [false, false, false, false] },
                                { text: data.ekg.qtc, style: 'textStyle', border: [false, false, false, false] }
                            ],
                        ]
                    }
                }
            ]; */

      let htmlEkgConclusion = null;
      let result = replaceConcurrenceInString(
        data.ekg.conclusions || data.ekg.conclusion,
        "\n",
        "<br />"
      );
      //result = replaceConcurrenceInString(data.ekg.conclusions, '<table>', '<table class="tableTohtml">');

      htmlEkgConclusion = htmlToPdfmake(result, {
        defaultStyles: {
          table: {
            width: ["*", "auto"],
          },
        },
        tableAutoSize: true,
      });

      /* htmlEkgConclusion = htmlToPdfmake(result, {replaceText: function(text, nodes){
                return text.replace(/<td>/g, `<td class="tableTohtml">`)
            }}); */

      //htmlEkgConclusion = htmlToPdfmake(result, {tableAutoSize: true});

      let ekgDescripction = [
        {
          margin: [0, 0, 0, 0],
          layout: {
            defaultBorder: false,
          },
          style: "tableTexStyle",
          table: {
            widths: ["*"],
            body: [[htmlEkgConclusion]],
          },
        },
      ];
      //arrProcedures.push(ekg);
      arrProcedures.push(ekgDescripction);
    }

    //Mapa
    if (data.mapa != null) {
      let htmlMapaConclusion = null;
      let result = replaceConcurrenceInString(
        data.mapa.conclusion,
        "\n",
        "<br />"
      );
      htmlMapaConclusion = htmlToPdfmake(result, {
        defaultStyles: {
          table: {
            width: ["*", "auto"],
          },
        },
        tableAutoSize: true,
      });
      //htmlMapaConclusion = htmlToPdfmake(result);
      let mapaDescripction = [
        {
          margin: [0, 0, 0, 0],
          layout: {
            defaultBorder: false,
          },
          style: "tableTexStyle",
          table: {
            widths: ["*"],
            body: [[htmlMapaConclusion]],
          },
        },
      ];
      arrProcedures.push(mapaDescripction);
    }

    return arrProcedures;
  };

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    /*header: header,*/
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                style: "foter",
              },
              { text: name, style: "foter" },
              {
                text: "Fecha Impresión: " + data.fecha + " " + data.hora,
                style: "foter",
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 0, 5],
      };
    },
    content: [
      header,
      topTitle(),
      {
        margin: [0, 0, 0, 0],
        layout: {
          defaultBorder: false,
        },
        table: {
          widths: ["auto", "*", "auto", "*", "auto", "*"],
          body: [
            [
              {
                text: "Nombre ",
                bold: true,
                style: "textStyle",
                border: [false, true, false, false],
              },
              {
                text: data.fullname,
                style: "textStyle",
                border: [false, true, false, false],
                colSpan: 3,
              },
              "",
              "",
              {
                text: "Identificación",
                bold: true,
                style: "textStyle",
                border: [false, true, false, false],
              },
              {
                text: data.typeDocument + "-" + data.documentNumber,
                style: "textStyle",
                border: [false, true, false, false],
              },
            ],
            [
              {
                text: "F.Nacimiento ",
                bold: true,
                style: "textStyle",
                border: [false, false, false, false],
              },
              {
                text: data.birthday,
                style: "textStyle",
                border: [false, false, false, false],
              },
              {
                text: "Edad ",
                bold: true,
                style: "textStyle",
                border: [false, false, false, false],
              },
              {
                text: calculateAgeParse(data.birthday),
                style: "textStyle",
                border: [false, false, false, false],
              },
              {
                text: "Genero",
                bold: true,
                style: "textStyle",
                border: [false, false, false, false],
              },
              {
                text: data.gender,
                style: "textStyle",
                border: [false, false, false, false],
              },
            ],
            [
              {
                text: "Dirección ",
                bold: true,
                style: "textStyle",
                border: [false, false, false, false],
              },
              {
                text: data.address,
                style: "textStyle",
                border: [false, false, false, false],
              },
              {
                text: "Municipio ",
                bold: true,
                style: "textStyle",
                border: [false, false, false, false],
              },
              {
                text:
                  data.id_ciudad_paciente !== undefined
                    ? data.id_ciudad_paciente + " - " + data.city
                    : data.city,
                style: "textStyle",
                border: [false, false, false, false],
              },
              {
                text: "Celular: ",
                bold: true,
                style: "textStyle",
                border: [false, false, false, false],
              },
              {
                text: data.celular,
                style: "textStyle",
                border: [false, false, false, false],
              },
            ],
            [
              {
                text: "Entidad ",
                bold: true,
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: data.nameThird,
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: "Regimen ",
                bold: true,
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: data.regime,
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: "Fecha Procedimiento",
                bold: true,
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: data.fecha_admision,
                style: "textStyle",
                border: [false, false, false, true],
              },
            ],
          ],
        },
      },
      infoDetailedService(),
      {
        margin: [0, 5, 0, 0],
        layout: {
          defaultBorder: false,
        },
        table: {
          widths: ["*"],
          body: validateProcedures(),
        },
      },
      {
        // auto-sized columns have their widths based on their content
        columns: data.urlDoctorFirm ? signatures : noSignaturesFound,
        columnGap: 10,
      },
    ],
    styles: {
      head: {
        fontSize: 8,
        bold: true,
        alignment: "left",
        font: "OpenSans",
      },
      tableheader: {
        fontSize: 9,
        bold: true,
        font: "OpenSans",
      },
      textStyle: {
        fontSize: 8,
        font: "OpenSans",
      },
      signature: {
        fontSize: 9,
        alignment: "center",
        bold: true,
        font: "OpenSans",
      },
      signatureNameDoctor: {
        fontSize: 8,
        alignment: "center",
        bold: true,
        font: "OpenSans",
      },
      tableTexStyle: {
        fontSize: 8,
        alignment: "left",
        font: "OpenSans",
      },
      foter: {
        margin: 10,
        fontSize: 7,
        font: "OpenSans",
      },
      tableTohtml: {
        width: "100%",
      },
    },
  };

  if (data.printInnerWindow) {
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
      document.getElementById("pdfV").src = outDoc;
    });
  } else {
    pdfMake.createPdf(documentDefinition).open();
  }
};

function getBase64ImageFromURL(url) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = (error) => {
      reject(error);
    };

    img.src = url;
  });
}

export default PDFProcedures;
